import { Button } from '@fluentui/react-components'
import { Delete24Regular, Person24Regular } from '@fluentui/react-icons'
import { FluentCard } from '../FluentCard/FluentCard'
import { RestSchemas } from '@/contexts/QueryProvider'

type MessagesSubscriptionsOrganisationTeamUser = RestSchemas['Messages.Subscriptions.OrganisationTeamUser']

type TeamMemberCardProps = {
  key: number | string
  userId: number
  onDelete: () => void
  teamUsers: MessagesSubscriptionsOrganisationTeamUser[] // List of team members
  teamId: number
  teamName: string
}

export const TeamMemberCard = ({ onDelete, teamUsers, teamName, userId }: TeamMemberCardProps) => {
  // Ensure organisationUsers is defined before calling find
  const user = teamUsers?.find((u) => u.userId === userId)
  const userName = user ? `${user.givenName} ${user.familyName}` : 'Unknown User'

  return (
    <FluentCard
      title={userName}
      description={teamName}
      icon={<Person24Regular />}
      action={
        <Button
          appearance="transparent"
          icon={<Delete24Regular />}
          aria-label="Remove team member"
          onClick={onDelete}
        />
      }
    />
  )
}
